import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-finance",
  "use": "icon-finance-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-finance\"><path d=\"M512.4096 73.4208a431.4112 431.4112 0 0 0 0 862.72h329.472a30.72 30.72 0 0 0 25.0368-48.4352l-71.68-101.2224a30.6176 30.6176 0 0 0-51.0464 1.3824 30.8224 30.8224 0 0 0 0.9216 34.1504l37.376 52.736h-270.08a369.4592 369.4592 0 1 1 358.656-278.9376 30.72 30.72 0 1 0 59.5456 15.104 431.616 431.616 0 0 0-418.2016-537.6v0.1024z\" p-id=\"2545\" /><path d=\"M676.352 498.432a30.72 30.72 0 0 0 0-61.44h-90.5216l58.0096-87.7568a30.72 30.72 0 0 0-51.2-33.8944L517.12 429.4656 418.3552 312.32a30.72 30.72 0 1 0-46.9504 39.68l71.68 84.8384H358.4a30.72 30.72 0 0 0 0 61.44h128v74.1888H358.4a30.72 30.72 0 1 0 0 61.44h128v69.5808a30.72 30.72 0 1 0 61.44 0v-69.4272h128a30.72 30.72 0 0 0 0-61.44h-128V498.432h128.512z\" p-id=\"2546\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/finance.svg
// module id = pTuU
// module chunks = 41